'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _chart = require('chart.js');

var _chart2 = _interopRequireDefault(_chart);

var _Chart = require('./components/charts/Chart');

var _Chart2 = _interopRequireDefault(_Chart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Charts = function () {
	function Charts() {
		_classCallCheck(this, Charts);

		this.init();
	}

	_createClass(Charts, [{
		key: 'init',
		value: function init() {
			if (this.findCharts()) this.renderCharts();
		}
	}, {
		key: 'findCharts',
		value: function findCharts() {
			this.chartElements = document.querySelectorAll('[data-chart]');
			return !!this.chartElements.length;
		}
	}, {
		key: 'renderCharts',
		value: function renderCharts() {
			var this$1 = this;

			for (var i = 0; i < this.chartElements.length; i++) {
				this$1.renderChart(this$1.chartElements[i]);
			}
		}
	}, {
		key: 'renderChart',
		value: function renderChart(element) {

			var options = undefined;
			var type = element.dataset.chart;
			var jsonData = JSON.parse(element.dataset.chartData);
			var definition = JSON.parse(element.dataset.chartDefinition);

			if (type == 'forecast') {
				var chartData = this.transformForecast(jsonData);
				type = 'line';
				options = {
					legend: {
						onClick: function onClick(event, legendItem) {
							return false;
						}
					},
					tooltips: {
						callbacks: {
							label: function label(tooltipItems, data) {
								return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(tooltipItems.yLabel);
							}
						}
					},
					scales: {
						yAxes: [{
							ticks: {
								beginAtZero: true
							}
						}],
						xAxes: [{
							type: 'time',
							time: {
								unit: 'month'
							}
						}]
					}
				};
			} else {
				var chartData = this.transformData(jsonData, definition);
			}

			_reactDom2.default.render(_react2.default.createElement(_Chart2.default, {
				data: chartData,
				type: type,
				options: options
			}), element);
		}
	}, {
		key: 'transformData',
		value: function transformData(jsonData, definition) {

			var chartData = {
				labels: [],
				datasets: []
			};

			for (var i = 0; i < definition.dataPoints.length; i++) {
				chartData.datasets.push({
					label: definition.dataPoints[i],
					backgroundColor: 'rgba(0,0,0,0.5)',
					borderColor: 'rgba(0,0,0,1)',
					borderWidth: 2,
					data: []
				});
			}

			for (var j = 0; j < jsonData.length; j++) {

				var label = [];
				for (var i = 0; i < definition.groupBy.length; i++) {
					label.push(jsonData[j][definition.groupBy[i]]);
				}
				label = label.join('/');
				chartData.labels.push(label);
				for (var i = 0; i < definition.dataPoints.length; i++) {
					chartData.datasets[i].data.push(jsonData[j][definition.dataPoints[i]]);
				}
			}

			return chartData;
		}
	}, {
		key: 'transformForecast',
		value: function transformForecast(data) {

			var chartData = {
				labels: [],
				datasets: [{
					type: 'line',
					label: 'Incoming Payments',
					data: []
				}]
			};

			var days = Object.keys(data.daily);

			for (var i = 0; i < days.length; i++) {
				chartData.labels.push(days[i]);
				chartData.datasets[0].data.push(data.daily[days[i]]);

				/*
    Attempting to show the '30 days later' mark.
     */
				// var d = new Date(days[i]);
				// d.setDate(d.getDate() + 30);
				// var dateString = d.getUTCFullYear() + '-' +
				//     ('00' + (d.getUTCMonth()+1)).slice(-2) + '-' +
				//     ('00' + d.getUTCDate()).slice(-2);

				// chartData.datasets[1].data.push({
				// 	x: dateString,
				// 	y: data.daily[days[i]],
				// 	r: 2
				// });
			}

			return chartData;
		}
	}]);

	return Charts;
}();

exports.default = Charts;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/loadCharts.js
// module id = 527
// module chunks = 0